import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
import CompletedProjectsCard from '../components/CompletedProjectsCard/CompletedProjectsCard';
import { API_BASE_URL } from '../utils/apiConfig';

const Projects = () => {
  const [projects, setProjects] = useState([]);
  // const [activeIndex, setActiveIndex] = useState(0);
  // const quoteRef = useRef(null);
  // const autoplayRef = useRef(null);

//   const updateIndex = useCallback((direction) => {
//   setActiveIndex((prevIndex) => (prevIndex + direction + projects.length) % projects.length);
// }, [projects.length]);

  useEffect(() => {
    fetch(`${API_BASE_URL}/projects`)
      .then(res => res.json())
      .then(data => {
        // console.log('Fetched Projects List:', data);
        // console.log('Fetched Projects List - Project Name:', data[0].project_name);
        // console.log('Project Name:', data[0].project_name, typeof data[0].project_name);
        const filtered = Object.values(data).filter(item => item.id);
        setProjects(filtered);
        // setActiveIndex(0); // Reset activeIndex after loading data
      })
      .catch(err => console.error('Error fetching projects:', err));
  }, []);

  // useLayoutEffect(() => {
  //   if (!quoteRef.current || projects.length === 0) return;

  //   const quoteEl = quoteRef.current;
  //   const words = quoteEl.querySelectorAll('.word');

  //   words.forEach(word => {
  //     word.style.opacity = '0';
  //     word.style.transform = 'translateY(10px)';
  //     word.style.filter = 'blur(10px)';
  //     word.style.transition = 'none';
  //   });

  //   requestAnimationFrame(() => {
  //     words.forEach((word, index) => {
  //       setTimeout(() => {
  //         word.style.transition = 'opacity 0.3s ease, transform 0.3s ease, filter 0.3s ease';
  //         word.style.opacity = '1';
  //         word.style.transform = 'translateY(0)';
  //         word.style.filter = 'blur(0)';
  //       }, index * 30);
  //     });
  //   });
  // }, [activeIndex, projects]);

  // useEffect(() => {
  //   if (projects.length === 0) return;

  //   autoplayRef.current = setInterval(() => {
  //     updateIndex(1);
  //   }, 5000);

  //   return () => clearInterval(autoplayRef.current);
  // }, [projects, updateIndex]);

  // const resetAutoplay = () => {
  //   clearInterval(autoplayRef.current);
  //   autoplayRef.current = setInterval(() => {
  //     updateIndex(1);
  //   }, 5000);
  // };

  if (projects.length === 0) {
    return <div className="loading-component">Loading Projects...</div>;
  }

  // const current = projects[activeIndex];

  return (
    <>
    {/* <div className='container project-page'>
      <div className="project-container">
        <div className="project-grid">
          <div className="image-container" id="image-container">
            {projects.map((project, index) => {
              const offset = index - activeIndex;
              const absOffset = Math.abs(offset);
              const zIndex = projects.length - absOffset;
              const opacity = index === activeIndex ? 1 : 0.7;
              const scale = 1 - absOffset * 0.15;
              const translateY = offset === -1 ? '-20%' : offset === 1 ? '20%' : '0%';
              const rotateY = offset === -1 ? '15deg' : offset === 1 ? '-15deg' : '0deg';

              return (
                <img
                  key={index}
                  src={ API_BASE_URL + `/images/` + project.image_url}
                  alt={project.project_name || `Project ${index + 1}`}
                  className="project-image"
                  style={{
                    zIndex,
                    opacity,
                    transform: `translateY(${translateY}) scale(${scale}) rotateY(${rotateY})`,
                  }}
                />
              );
            })}
          </div>

          <div className="project-content">
            <div>
              <h3 className="name" id="name">{current.project_name}</h3>
              <p className="designation" id="designation">{current.client_name}</p>
              <p className="quote" id="quote" ref={quoteRef}>
                {current.project_description?.split(' ').map((word, idx) => (
                  <span key={idx} className="word">{word} </span>
                ))}
              </p>
              <Link to={current.project_link || "#"} target='__blank'>View Project</Link>
            </div>

            <div className="arrow-buttons">
              <button className="arrow-button prev-button" id="prev-button" onClick={() => {
                updateIndex(-1);
                resetAutoplay();
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                </svg>
              </button>

              <button className="arrow-button next-button" id="next-button" onClick={() => {
                updateIndex(1);
                resetAutoplay();
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div> */}
    <div className='container'>
      <CompletedProjectsCard
        projects={projects}
        initialQuery=""
        initialSort="newest"
        showImages={true}
      />
    </div>

    </>
  );
};

export default Projects;
